import { CalendarSimulation } from '@src/types/loan/loan-simulation'
import { useTranslation } from 'react-i18next'
import InvoiceRow from '../../Common/Table/InvoiceRow'
import InvoiceTable from '../../Common/Table/InvoiceTable'
import {
  useLoanCalendarLastCompletedPaymentDate,
  useLoanCalendarNbDaysSinceLastCompletedPayment,
  useLoanCalendarNbOfCurrentLateDays,
} from '../LoanCalendar-hooks'

interface Props {
  simulation: CalendarSimulation
}

const LoanLateStatusCardContent = ({ simulation }: Props) => {
  const { t } = useTranslation()
  const currentLateDays = useLoanCalendarNbOfCurrentLateDays(simulation)
  const nbOfDaysBeforeLastCompletedPayment = useLoanCalendarNbDaysSinceLastCompletedPayment(simulation)
  const lastCompletedDate = useLoanCalendarLastCompletedPaymentDate(simulation)

  return (
    <>
      <InvoiceTable>
        <InvoiceRow
          label={t('loan.payment.lateStatusCard.daysLate')}
          value={t('common.days', { count: currentLateDays })}
        />
        <InvoiceRow
          label={t('loan.payment.lateStatusCard.daysSinceLatePayment')}
          value={nbOfDaysBeforeLastCompletedPayment}
        />
        <InvoiceRow label={t('loan.payment.lateStatusCard.dateLastPayment')} value={lastCompletedDate?.toString()} />
      </InvoiceTable>
    </>
  )
}

export default LoanLateStatusCardContent
